import { CombinedGraphQLErrors } from '@apollo/client/errors';

// The code the server answered with (its GraphQLError message: INSUFFICIENT_CREDITS, BILLING_INFO_MISSING, ...).
// The combined error's own message joins every error's, so a second one (a field-level refusal alongside) would
// hide the code; the first error is the one the resolver threw.
export const graphqlErrorCode = (error: unknown): string | undefined => {
  if (CombinedGraphQLErrors.is(error)) return error.errors[0]?.message;
  return error instanceof Error ? error.message : undefined;
};
